import React from 'react';
import SimplePreview from './SimplePreview';
import MultipagePreview from './MultipagePreview';
import {Form, FormPresentationType} from "crqlar-react-common/dist/models/forms/form";

interface FormPreviewProps {
  form: Form;
  onClose?: () => void;
  isPublic?: boolean;
  previewMode?: 'standalone' | 'app' | 'embed';
}

/**
 * Router component that decides which preview to render based on form presentation type and preview mode
 */
const FormPreview: React.FC<FormPreviewProps> = ({form, onClose, isPublic = false, previewMode = 'standalone'}) => {

  // // If embed preview mode is selected, render EmbedPreview
  // if (previewMode === 'embed') {
  //   return <EmbedPreview form={form} onClose={onClose} />;
  // }

  // For standalone mode, check if form uses single-page presentation
  const isSinglePage = form.presentationType === FormPresentationType.SINGLE_PAGE;

  // Render appropriate preview component
  return isSinglePage ? (
    <SimplePreview form={form} onClose={onClose} isPublic={isPublic} />
  ) : (
    <MultipagePreview form={form} onClose={onClose} isPublic={isPublic} />
  );
};

export default FormPreview;
